import React, { useState } from "react";
import { Form } from "react-router-dom";
import SmartButton from "../ui/buttons/SmartButton";
import { useButtonState } from "../../hooks/useButtonState";

function ResetPasswordForm({ token }) {
  const { buttonState, handleFormSubmit, isSubmitting } = useButtonState();
  const [showPasswords, setShowPasswords] = useState({
    new_password: false,
    confirm_password: false
  });

  const togglePasswordVisibility = (fieldName) => {
    setShowPasswords(prev => ({
      ...prev,
      [fieldName]: !prev[fieldName]
    }));
  };

  return (
    <Form
      className="auth-form"
      method="post"
      onSubmit={handleFormSubmit}
    >
      {/* Token hidden for action */}
      <input type="hidden" name="token" value={token} />

      <div className="auth-form-content">
        {/* Section 1: Title */}
        <p className="auth-form-title">
          Please choose a new password for your account.
        </p>

        {/* Section 2: Form Fields */}
        <div className="auth-form-fields">
          {/* New Password Field */}
          <div className="form-field">
            <div className="password-input-container">
              <input
                type={showPasswords.new_password ? "text" : "password"}
                name="new_password"
                className="form-input"
                placeholder="New Password"
                required
              />
              <img
                src={showPasswords.new_password ? "/images/icons/eye_open_blue.svg" : "/images/icons/eye_closed_blue.svg"}
                alt="Toggle password visibility"
                className="password-toggle-icon"
                onClick={() => togglePasswordVisibility('new_password')}
              />
            </div>
          </div>

          {/* Confirm Password Field */}
          <div className="form-field">
            <div className="password-input-container">
              <input
                type={showPasswords.confirm_password ? "text" : "password"}
                name="confirm_password"
                className="form-input"
                placeholder="Confirm Password"
                required
              />
              <img
                src={showPasswords.confirm_password ? "/images/icons/eye_open_blue.svg" : "/images/icons/eye_closed_blue.svg"}
                alt="Toggle password visibility"
                className="password-toggle-icon"
                onClick={() => togglePasswordVisibility('confirm_password')}
              />
            </div>
          </div>

          <SmartButton
            text="Update Password"
            loadingText="Processing..."
            successText="Password Updated"
            state={buttonState}
            isSubmitting={isSubmitting}
            type="submit"
          />
        </div>
      </div>
    </Form>
  );
}

export default ResetPasswordForm;
